import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import moment from 'moment';
import { chartColor } from "../../../../utils/commonConsts";
import merge from 'deepmerge';
var BossLineChart = /*#__PURE__*/function (_React$Component) {
  _inherits(BossLineChart, _React$Component);
  function BossLineChart(props) {
    var _this;
    _classCallCheck(this, BossLineChart);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BossLineChart).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initChart", function (el) {
      var option = {
        legend: {
          type: 'scroll',
          left: "center",
          bottom: 0,
          icon: "circle",
          width: "90%"
        },
        grid: {
          left: '12%',
          right: '18%',
          bottom: '35%'
        },
        dataZoom: [{
          id: 'dataZoomX',
          type: 'slider',
          xAxisIndex: [0],
          filterMode: 'none',
          bottom: 50,
          height: 18
        }],
        xAxis: {
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        color: chartColor,
        tooltip: {
          trigger: 'axis',
          backgroundColor: "#333",
          extraCssText: 'box-shadow: 0 2px 2px 0 rgba(24,24,24,0.60);border-radius: 2px 2px 0 0 0 2px 2px;',
          formatter: function formatter(data) {
            var res = '';
            if (moment.unix(data[0].axisValue / 1000).format("YYYY-MM-DD HH:mm:ss") === "Invalid date") {
              for (var i = 0; i < data.length; i++) {
                var datavalue = data[i].data[1] ? data[i].data[1] : '0';
                res += '<tr><td><span style="display:inline-block;height:12px;lineheight:12px;font-size:32px;margin-top:5px;color:' + data[i].color + '">&middot;</span></td><td>' + data[i].seriesName + '</td><td>' + datavalue + '<td/><td>' + data[i].axisValue + '</td></tr>';
              }
              return '<div class="line-tooltip"><table class="line-tooltip-table" style="border-bottom: none">' + res + '<table/></div>';
            } else {
              for (var _i2 = 0; _i2 < data.length; _i2++) {
                var _datavalue = data[_i2].data[1] ? data[_i2].data[1] : '0';
                res += '<tr><td><span style="display:inline-block;height:12px;lineheight:12px;font-size:32px;margin-top:5px;color:' + data[_i2].color + '">&middot;</span></td><td>' + data[_i2].seriesName + '</td><td>' + _datavalue + '<td/><td>' + data[_i2].data[0] + '</td></tr>';
              }
              return '<div class="line-tooltip"><table class="line-tooltip-table" style="border-bottom: none">' + res + '<table/></div>';
            }
          },
          axisPointer: {
            axis: 'x'
          }
        }
      };
      option = merge(option, _this.props.option);
      el.clear();
      el.setOption(option, {
        notMerge: _this.props.ifNotMerge
      });
    });
    _this.state = {};
    return _this;
  }
  _createClass(BossLineChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.chart = echarts.init(document.getElementById(this.props.id));
      if (this.props.onClick) {
        this.chart.on('click', this.props.onClick);
      }
      this.initChart(this.chart);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return JSON.stringify(nextProps.option) !== JSON.stringify(this.props.option);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initChart(this.chart);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id,
        style: {
          width: this.props.containerWidth,
          height: this.props.containerHeight
        }
      });
    }
  }]);
  return BossLineChart;
}(React.Component);
BossLineChart.defaultProps = {
  containerWidth: document.body.clientWidth - 300,
  containerHeight: 720,
  ifNotMerge: true
};
export default BossLineChart;